export const WIDGET_MESSAGE_ACTIONS = {
  MOVING_WIDGET: 'moving-widget',
  START_DRAGGING: 'start-dragging',
  STOP_DRAGGING: 'stop-dragging',
  REDIRECT: 'iah-redirect',
  CSAT_SURVEY: 'csat-survey',
  HELP_MODAL: 'in-app-help-modal'
};
export const isValidWidgetMessageAction = action => Object.keys(WIDGET_MESSAGE_ACTIONS).find(key => WIDGET_MESSAGE_ACTIONS[key] === action) !== undefined;